import { FC, RefObject, useEffect, useMemo, useState } from 'react'
import Like from '../../../../assets/img/socials/additional-icons/instagram-like.svg'
import Chat from '../../../../assets/img/socials/additional-icons/instagram-chat.svg'
import Send from '../../../../assets/img/socials/additional-icons/instagram-send.svg'

import Ellipsis from '../../../UI/Icons/Ellipsis'
import UploadImage from '../../../UploadPostImages'
import Label from '../../../UI/Icons/Label'
import FirstCommentField from '../UI/CommentField'
import MessageField from '../UI/MessageField'
import UploadVideo from '../../../UploadVideo'
import { TMediaCallbacks } from '../../../../pages/CreatePost'

import {
  TFieldChangePayload,
  TRemoveAttachmentPayload
} from '../../../../store/managePost/newTypes'
import { VIEW_TYPE, TPostSocialManagePost } from '../../../../store/managePost/newTypes'

import './InstagramEditor.scss'
import { SOCIAL_NETWORK } from '../../../../models/post'
import { TSocialDetails } from '../../../../selectors/ProjectSelector'
import UploadMultiContent from '../../../UploadMultiContent'
import { hashtagSearchThunk} from '../../../../store/managePost/thunks'
import { useDispatch } from '../../../../store'

import AtIcon from '../../../UI/Icons/At'
import Location from '../../../UI/Icons/Location' 

interface InstagramPreviewProps {
  post: TPostSocialManagePost
  onTextChange: (data: TFieldChangePayload) => void
  refMediaCallbaks: RefObject<TMediaCallbacks>
  addMediaToTemporaryLibrary: (data: any) => void
  deleteMediaFromPostSocial: (data: TRemoveAttachmentPayload) => void
  view: VIEW_TYPE
  restrictions: any
  isStory: boolean
  socialDetails: TSocialDetails
  publishDate: string
  postValue: any
  setPostValue: any
  getTypedHashtagValue: any
  getTypedMentionValue: any
  postMentionValues: any
  postGeolocationValue: any
  setPostMentionValues: any
  setPostGeolocationValue: any
}

const InstagramEditor: FC<InstagramPreviewProps> = ({
  post,
  onTextChange,
  refMediaCallbaks,
  addMediaToTemporaryLibrary,
  publishDate,
  restrictions,
  isStory,
  socialDetails,
  deleteMediaFromPostSocial,
  postValue,
  setPostValue,
  getTypedHashtagValue,
  getTypedMentionValue,
  postMentionValues,
  setPostMentionValues,
  postGeolocationValue,
  setPostGeolocationValue
}) => {
  const socialData = useMemo(() => socialDetails[SOCIAL_NETWORK.INSTAGRAM_SOCIAL], [])
  const dispatch = useDispatch()
  const manageMediaProps = {
    attachments: post.attachments,
    isEditable: post.isEditable,
    addMediaToPost: addMediaToTemporaryLibrary,
    refMediaCallbaks,
    isPreview: false,
    removeMediaFromStore: deleteMediaFromPostSocial,
    restrictions
  }

  const getHashtags = async (query: string)=> 
  await dispatch(hashtagSearchThunk({social: SOCIAL_NETWORK.INSTAGRAM_SOCIAL,query}))

  useEffect(() => {
    if(getTypedHashtagValue){
      getHashtags(getTypedHashtagValue);
    }
  }, [getTypedHashtagValue]);

  useEffect(() => {
    if(getTypedMentionValue){
      getHashtags(getTypedMentionValue);
    }
  }, [getTypedMentionValue]);

  const deleteSelectedMention = (value: string) => {
    const listpostMentionValue = postMentionValues.filter((postMentionValue: string) => postMentionValue !== value);
    setPostMentionValues(listpostMentionValue);
  }

  const deleteSelectedLocation = () => {
    setPostGeolocationValue('');
    setSavedLocation('');
  }

  const [savedLocation, setSavedLocation] = useState<any>(null);
  useEffect(() => {
    if(post.post_id != 0 && post.location !== null){
      setSavedLocation(JSON.parse(post.location));
    }
  }, [post.location, post.post_id]);

  return (
    <>
      <div className={`instagram-editor post-editor ${isStory && 'story-editor'}`}>
        { !isStory ? 
          <div className='instagram-customer'>
            <div className='instagram-customer__avatar'>
              {socialData.logo.original ? (
                <img
                  src={socialData.logo.original}
                  alt='any'
                  className='instagram-customer__avatar__img'
                />
              ) : (
                socialData.logo.default
              )}
            </div>
            <div className='instagram-customer__data'>
              <div className='instagram-customer__data__name'>{socialData.name}</div>
            </div>
            <div className='instagram-customer__etc'>
              <Ellipsis />
            </div>
          </div>
          :
          <div className='instagram-customer'>
            <div className='instagram-customer__story'>
              <div className='instagram-customer__story__name'>Stories</div>
            </div>
            <div className='instagram-customer__etc'>
              <div className="three-vertical-dots"></div>
            </div>
          </div>
        }
        {(restrictions.mediaRestrictions.image || restrictions.mediaRestrictions.video) && (
          <div className='instagram-multi-content'>
            <UploadMultiContent {...manageMediaProps} />
          </div>
        )}
        { isStory && 
          <div className='instagram-customer'>
            <div className='instagram-customer__profileimage'>
              {socialData.logo.default}
            </div>
            <div className='instagram-customer__datastory'>
              <div className='instagram-customer__datastory__name'>Annette Black...<span className='insta-follow'>Follow</span></div>
            </div>
          </div>
        }
        {!isStory && (
          <>
            <div className='instagram-assessments'>
              <div className='instagram-assessments__motion-wrapper'>
                <div className='instagram-assessments__motion-wrapper__icon'>
                  <img src={Like} alt='any' />
                </div>
                <div className='instagram-assessments__motion-wrapper__icon'>
                  <img src={Chat} alt='any' />
                </div>
                <div className='instagram-assessments__motion-wrapper__icon'>
                  <img src={Send} alt='any' />
                </div>
              </div>

              <div className='instagram-assessments__label-wrapper'>
                <Label />
              </div>
            </div>

            <div className='instagram-likes'>
              <div className='instagram-likes__text'>Like</div>
              <div className='instagram-likes__text__bold'>codyfisher</div>
              <div className='instagram-likes__text'>and</div>
              <div className='instagram-likes__text__bold'>others</div>
            </div>
          </>
        )}
        {restrictions.message && !isStory && (
          <div className='instagram-content'>
            <div className='instagram-customer__data__name'>{socialData.name}</div>
            <MessageField
              {...{
                className: 'instagram-content',
                value: post.message,
                isEditable: post.isEditable,
                postType: post.type,
                editorRaws: post.message_editor_state,
                getHashes:getHashtags,
                onChange: onTextChange,
                social: post.social_network,
                isExist: restrictions.message,
                maxLength: 2200,
                postValue: postValue,
                maxHashtag: 30,
                setPostValue: setPostValue
              }}
            />
            <div className='instagram-content__publish-date'>{publishDate}</div>
          </div>
        )}
        {!isStory ? (
          <FirstCommentField
            {...{
              className: 'instagram-comment',
              value: post.first_comment,
              isEditable: post.isEditable,
              onChange: onTextChange,
              social: post.social_network,
              isExist: restrictions.message || isStory
            }}
          ></FirstCommentField>
        ) : "" }
      </div>
      { isStory && (
        <div className={`instagram-editor ${isStory && 'story-editor'}`}>
          <div className='instagram-story-editor'>
            <MessageField
              {...{
                className: 'instagram-story-reaction',
                value: post.message,
                isEditable: post.isEditable,
                isHighlights: false,
                editorRaws: null,
                placeholder: 'Type a message...',
                postType: post.type,
                onChange: onTextChange,
                social: post.social_network,
                isExist: restrictions.message,
                maxLength: 2200,
                postValue: postValue,
                maxHashtag: 30,
                setPostValue: setPostValue
              }}
            />
          </div>
        </div>
      )}
      { (post && !post.isEditable && post.location !== null && savedLocation !== null) ? 
        <div className='mention-container'>
          <div className='mention_tags'>
            <div className='geolocation_text'>
              <span className='at_icon'><Location color={'#34899a'} width={"30"} viewbox={"-10 -13 60.00 45.00"} /></span>
              {savedLocation.name}{(savedLocation.location.city && savedLocation.location.country) ? ', ' + savedLocation.location.city + ', ' + savedLocation.location.country : savedLocation.location.city ? ', ' + savedLocation.location.city : savedLocation.location.country ? ', ' + savedLocation.location.country : ''}
            </div>
          </div>
        </div>
      : (post && post.isEditable && (post.status === 'scheduled' || post.status === 'pending_publish') && savedLocation !== null) ? 
        <div className='mention-container'>
          <div className='mention_tags'>
            <div className='geolocation_text'>
              <span className='at_icon'><Location color={'#34899a'} width={"30"} viewbox={"-10 -13 60.00 45.00"} /></span>
              {savedLocation.name}{(savedLocation.location.city && savedLocation.location.country) ? ', ' + savedLocation.location.city + ', ' + savedLocation.location.country : savedLocation.location.city ? ', ' + savedLocation.location.city : savedLocation.location.country ? ', ' + savedLocation.location.country : ''}
            </div>
          </div>
        </div> : '' 
      }
      {postMentionValues && postMentionValues?.length > 0 ?
        <div className='mention-container'>
          { postMentionValues.map((postMentionValue: any, index: number) => (
            <div className='mention_tags' key={index}>
              <div className='mention_text'>
                <span className='at_icon'><AtIcon /></span>
                {postMentionValue}
                <div className='cancel_button'>
                  <a href="#" className="close" onClick={() => deleteSelectedMention(postMentionValue)}></a>
                </div>
              </div>
            </div>
          ))}
        </div>
      : "" }
      {(post && post.isEditable && post.status === 'draft' && postGeolocationValue) ?  
        <div className='mention-container'>
          <div className='mention_tags'>
            <div  className='geolocation_text'>
            <span className='at_icon'><Location color={'#34899a'} width={"30"} viewbox={"-10 -13 60.00 45.00"} /></span>
              {postGeolocationValue}
              <div className='cancel_button'>
                <a href="#" className="close" onClick={() => deleteSelectedLocation()}></a>
              </div>
            </div >
          </div>
        </div>
      : 
        (post && post.isEditable && post.status === 'draft' && savedLocation) ? 
          <div className='mention-container'>
            <div className='mention_tags'>
              <div  className='geolocation_text'>
              <span className='at_icon'><Location color={'#34899a'} width={"30"} viewbox={"-10 -13 60.00 45.00"} /></span>
                {savedLocation.name}{(savedLocation.location.city && savedLocation.location.country) ? ', ' + savedLocation.location.city + ', ' + savedLocation.location.country : savedLocation.location.city ? ', ' + savedLocation.location.city : savedLocation.location.country ? ', ' + savedLocation.location.country : ''}
                <div className='cancel_button'>
                  <a href="#" className="close" onClick={() => deleteSelectedLocation()}></a>
                </div>
              </div >
            </div>
          </div>
        : '' 
      }
    </>
  )
}

export default InstagramEditor
